// HolidaysList.jsx
import React from 'react';
import HolidaysItem from "../HolidaysItem/HolidaysItem";

const HolidaysList = ({ holidays }) => {
    return (        
        <div 
            className="d-flex flex-column custom-scrollbar" 
            style={{ 
                gap: "12px",
                flex: 1,          
                minHeight: 0,       
                overflowY: "auto",  
                paddingRight: "8px"
            }}
        >
            {holidays?.map((holiday) => (
                <HolidaysItem key={holiday.id} holiday={holiday} />
            ))}
        </div>
    );
};

export default HolidaysList;